// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"BlogPage_landingContainer__1RToq","buttonLink":"BlogPage_buttonLink__1qRnx","blogPage":"BlogPage_blogPage__2L_f0"};